import { Scenarios } from '@jfs/network'

const redeemVoucher = {
  default: [
    {
      url: /redeem/,
      method: 'POST',
      response: {
        responseCode: '00',
        responseMessage: 'SUCCESS',
        responseData: { transactionId: '10672228065980997000', transactionTime: 'Fri Oct 07 18:19:42 IST 2022' },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /redeem/,
      method: 'POST',
      responseCode: 5000,
      response: { responseCode: '1111', responseMessage: 'Invalid App Id Token Passed in header information' },
      delay: 1000,
    },
  ],
} as Scenarios

export { redeemVoucher }
